import { classNames } from 'primereact/utils';
import type React from 'react';
import { FaCaretRight } from 'react-icons/fa';

interface RuleItemProps {
	icon: React.ReactNode;
	title: string;
	value: string;
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const RuleItem: React.FC<RuleItemProps> = ({ icon, title, value, onClick }) => {
	const isDisabled = typeof onClick !== 'function';

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={isDisabled}
			className={classNames(
				'flex w-full items-center justify-between py-[18px] px-4 border-b border-neutral60 last:border-0',
				{
					'cursor-pointer': !isDisabled,
					'cursor-default': isDisabled,
				},
			)}
		>
			<div className="flex gap-2 items-center">
				<div className="mr-4">{icon}</div>
				<div className="text-left">
					<span className="text-body-large font-semibold text-onSurface">
						{title}
					</span>
					<p className="text-onSurfaceVariant text-body-medium">
						{value}
					</p>
				</div>
			</div>
			{onClick && (
				<div className="flex items-center">
					<FaCaretRight
						className="text-onSurfaceVariant"
						height={10}
					/>
				</div>
			)}
		</button>
	);
};

export default RuleItem;
